import { DataKeyValueStringInterface } from 'pf-frontend-common/src/module/data/key-value/string.interface';
import { CtaSortPropertyType } from 'pf-frontend-common/src/module/stats/types';

export class PropertyTabCtaAdapter {
  /**
   * Cta sort mapping
   */
  public static ctaSortMapping: DataKeyValueStringInterface = {
    '-featured': 'mr',
    '-property_id': 'nd',
    'price.primary.price': 'pa',
    '-price.primary.price': 'pd',
    bedroom_value: 'ba',
    '-bedroom_value': 'bd',
  };

  /**
   * Transform cta sort option from api value to cta sort property type
   */
  public transformSortOption(option: string): CtaSortPropertyType {
    return <CtaSortPropertyType>PropertyTabCtaAdapter.ctaSortMapping[option];
  }
}
